import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { GridCmp, GridProps } from "./Grid"
import { ColumnCmp, ColumnProps } from "./Column"

interface GridWrapperBlokProps {
  blok: GridProps & blokType
  microdata: any
}
interface ColumnWrapperBlokProps {
  blok: ColumnProps & blokType
}

export const S22Grid: React.FC<GridWrapperBlokProps> = ({ blok, microdata }) => (
  <SbEditable content={blok}>
    <GridCmp
      columns_wide={blok.columns_wide}
      columns_desktop={blok.columns_desktop}
      columns_tablet={blok.columns_tablet}
      columns_mobile={blok.columns_mobile}
      gutters_wide={blok.gutters_wide}
      gutters_desktop={blok.gutters_desktop}
      gutters_tablet={blok.gutters_tablet}
      gutters_mobile={blok.gutters_mobile}
      item={blok.item}
      microdata={microdata}
    />
  </SbEditable>
)

export const S22Column: React.FC<ColumnWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <ColumnCmp
      width_wide={blok.width_wide}
      width_desktop={blok.width_desktop}
      width_tablet={blok.width_tablet}
      width_mobile={blok.width_mobile}
      item={blok.item}
    />
  </SbEditable>
)